/* unplugin-vue-components disabled */import __unplugin_components_0 from 'D:/workspace/space-time-web/src/components/SvgIcon/index.vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "login"
};
const _hoisted_2 = {
  class: "shipin",
  loop: "",
  muted: "",
  id: "video",
  autoplay: "autoplay",
  controls: false
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "top_title"
};
const _hoisted_5 = {
  class: "topBox"
};
const _hoisted_6 = {
  class: "timeBox"
};
const _hoisted_7 = {
  class: "timetext"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  key: 0,
  style: {
    "float": "right"
  }
};
const _hoisted_11 = {
  style: {
    "width": "100%",
    "color": "#FFFFFF",
    "margin-top": "1rem",
    "text-align": "center"
  }
};
import { getCodeImg } from "@/api/login";
import Cookies from "js-cookie";
import { encrypt, decrypt } from "@/utils/jsencrypt";
import useUserStore from '@/store/modules/user';
import video from '@/assets/login.mp4';
export default {
  __name: 'login',
  setup(__props) {
    const userStore = useUserStore();
    const router = useRouter();
    const {
      proxy
    } = getCurrentInstance();
    const loginForm = ref({
      username: "",
      password: "",
      rememberMe: false,
      code: "",
      uuid: "",
      status: "0"
    });
    const loginRules = {
      username: [{
        required: true,
        trigger: "blur",
        message: "请输入您的账号"
      }],
      password: [{
        required: true,
        trigger: "blur",
        message: "请输入您的密码"
      }],
      code: [{
        required: true,
        trigger: "change",
        message: "请输入验证码"
      }]
    };
    const codeUrl = ref("");
    const timeText = ref("");
    const loading = ref(false);
    // 验证码开关
    const captchaOnOff = ref(true);
    // 注册开关
    const register = ref(false);
    const redirect = ref(undefined);
    function handleLogin() {
      proxy.$refs.loginRef.validate(valid => {
        if (valid) {
          loading.value = true;
          // 勾选了需要记住密码设置在 cookie 中设置记住用户名和密码
          if (loginForm.value.rememberMe) {
            Cookies.set("username", loginForm.value.username, {
              expires: 30
            });
            Cookies.set("password", encrypt(loginForm.value.password), {
              expires: 30
            });
            Cookies.set("rememberMe", loginForm.value.rememberMe, {
              expires: 30
            });
          } else {
            // 否则移除
            Cookies.remove("username");
            Cookies.remove("password");
            Cookies.remove("rememberMe");
          }
          // 调用action的登录方法
          userStore.login(loginForm.value).then(() => {
            router.push({
              path: redirect.value || "/"
            });
          }).catch(res => {
            if (res.toString().indexOf("用户登录端已达上限") !== -1) {
              proxy.$modal.confirm(res).then(function () {
                loginForm.value.status = "1";
                console.log(loginForm);
                userStore.login(loginForm.value).then(() => {
                  router.push({
                    path: redirect.value || "/"
                  });
                });
              }).catch(() => {
                proxy.$modal.msg('已取消登录！');
              });
            }
            loading.value = false;
            // 重新获取验证码
            if (captchaOnOff.value) {
              getCode();
            }
          });
        }
      });
    }
    function getCode() {
      getCodeImg().then(res => {
        captchaOnOff.value = res.captchaOnOff === undefined ? true : res.captchaOnOff;
        if (captchaOnOff.value) {
          codeUrl.value = "data:image/gif;base64," + res.img;
          loginForm.value.uuid = res.uuid;
        }
      });
    }
    function getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get("rememberMe");
      loginForm.value = {
        username: username === undefined ? loginForm.value.username : username,
        password: password === undefined ? loginForm.value.password : decrypt(password),
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
      };
    }
    function getZero(num) {
      if (parseInt(num) < 10) {
        num = '0' + num;
      }
      return num;
    }
    onMounted(() => {
      setInterval(e => {
        const vWeek = ["星期天", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();
        const vWeek_s = date.getDay();
        timeText.value = year + "/" + getZero(month) + "/" + getZero(day) + "\t" + vWeek[vWeek_s] + "\t" + getZero(hours) + ":" + getZero(minutes) + ":" + getZero(seconds);
      }, 1000);
      var video = document.getElementById('video');
      video.playbackRate = 1; //2就是2倍速播放
    });
    getCode();
    getCookie();
    return (_ctx, _cache) => {
      const _component_svg_icon = __unplugin_components_0;
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_button = _resolveComponent("el-button");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("video", _hoisted_2, [_createElementVNode("source", {
        src: _unref(video),
        type: "video/mp4"
      }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(_unref(timeText)), 1)])]), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "centerBox"
      }, [_createElementVNode("div", {
        class: "centerText"
      }, [_createElementVNode("span", null, "时空数据服务SatWide")])], -1))])]), _createVNode(_component_el_form, {
        ref: "loginRef",
        model: _unref(loginForm),
        rules: loginRules,
        class: "loginBox"
      }, {
        default: _withCtx(() => [_cache[8] || (_cache[8] = _createElementVNode("h3", {
          class: "loginBoxLogo"
        }, null, -1)), _createVNode(_component_el_form_item, {
          prop: "username",
          class: "loginBoxUser"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(loginForm).username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(loginForm).username = $event),
            modelModifiers: {
              trim: true
            },
            type: "text",
            size: "large",
            "auto-complete": "off",
            placeholder: "账号",
            clearable: ""
          }, {
            prefix: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "user"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "password",
          class: "loginBoxPwd"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(loginForm).password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(loginForm).password = $event),
            modelModifiers: {
              trim: true
            },
            type: "password",
            size: "large",
            "auto-complete": "off",
            "show-password": "",
            placeholder: "密码",
            onKeyup: _withKeys(handleLogin, ["enter"]),
            clearable: ""
          }, {
            prefix: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "password"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_checkbox, {
          modelValue: _unref(loginForm).rememberMe,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(loginForm).rememberMe = $event),
          class: "forgetPwd"
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("记住密码", -1)]))]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_form_item, {
          class: "loginBtn"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            loading: _unref(loading),
            size: "large",
            type: "primary",
            style: {
              "width": "100%"
            },
            onClick: _withModifiers(handleLogin, ["prevent"])
          }, {
            default: _withCtx(() => [!_unref(loading) ? (_openBlock(), _createElementBlock("span", _hoisted_8, "登 录")) : (_openBlock(), _createElementBlock("span", _hoisted_9, "登 录 中..."))]),
            _: 1
          }, 8, ["loading"]), _unref(register) ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_router_link, {
            class: "link-type",
            to: '/register'
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("立即注册", -1)]))]),
            _: 1
          })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_cache[7] || (_cache[7] = _createTextVNode(" 登录视为您已同意 ", -1)), _createVNode(_component_router_link, {
            class: "link-type",
            to: '/privacy'
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("用户协议、隐私政策、产品服务协议", -1)]))]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
};